"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsedMaterialsInPreset = exports.getFrameFromPresetConfig = exports.WALL_FRAME_PRESET_CONFIG = exports.WALL_PREVIEW_PRESET_CONFIG = void 0;
const uniq_1 = __importDefault(require("lodash/uniq"));
const tiles_1 = require("./tiles");
const matting_1 = require("./matting");
const filters_1 = require("./filters");
const frames_1 = require("./frames");
exports.WALL_PREVIEW_PRESET_CONFIG = [
    {
        id: 'classic-wood-single',
        config: {
            frameColorPresetId: 'classic_wood',
            matting: matting_1.MATTING.MEDIUM,
            filter: filters_1.FILTERS.NONE,
        },
    },
    {
        id: 'classic-black-single',
        config: {
            frameColorPresetId: 'classic_black',
            matting: matting_1.MATTING.DEEP,
            filter: filters_1.FILTERS.SILVER,
        },
    },
    {
        id: 'frameless-single',
        config: {
            frameColorPresetId: 'frameless',
            matting: matting_1.MATTING.NONE,
            filter: filters_1.FILTERS.NONE,
        },
    },
    {
        id: 'mixed-frames',
        config: {
            frameColorPresetId: 'earthy_blend',
            matting: matting_1.MATTING.SHALLOW,
            filter: filters_1.FILTERS.NONE,
        },
    },
    {
        id: 'wide-frame-red-ash-single',
        config: {
            frameColorPresetId: 'wide_frame_red_ash',
            matting: matting_1.MATTING.MEDIUM,
            filter: filters_1.FILTERS.NONE,
        },
    },
    {
        id: 'wide-frame-white-single',
        config: {
            frameColorPresetId: 'wide_frame_white',
            matting: matting_1.MATTING.MEDIUM,
            filter: filters_1.FILTERS.NONE,
        },
    },
];
exports.WALL_FRAME_PRESET_CONFIG = [
    {
        id: 'frameless',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.FRAMELESS,
                frameColor: frames_1.FRAME_COLORS.NONE,
            },
        ],
    },
    {
        id: 'classic_black',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.BLACK,
            },
        ],
    },
    {
        id: 'classic_white',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.WHITE,
            },
        ],
    },
    {
        id: 'classic_wood',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.WOOD,
            },
        ],
    },
    {
        id: 'wide_frame_black',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.WIDE_FRAME,
                frameColor: frames_1.FRAME_COLORS.BLACK,
            },
        ],
    },
    {
        id: 'wide_frame_white',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.WIDE_FRAME,
                frameColor: frames_1.FRAME_COLORS.WHITE,
            },
        ],
    },
    {
        id: 'wide_frame_red_ash',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.WIDE_FRAME,
                frameColor: frames_1.FRAME_COLORS.RED_ASH_WOOD,
            },
        ],
    },
    {
        id: 'earthy_blend',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.WOOD,
            },
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.BLACK,
            },
            {
                materialType: tiles_1.MATERIAL_TYPES.WIDE_FRAME,
                frameColor: frames_1.FRAME_COLORS.RED_ASH_WOOD,
            },
        ],
    },
    {
        id: 'classic_blend',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.WOOD,
            },
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.WHITE,
            },
            {
                materialType: tiles_1.MATERIAL_TYPES.WIDE_FRAME,
                frameColor: frames_1.FRAME_COLORS.RED_ASH_WOOD,
            },
        ],
    },
    {
        id: 'harmony_mix',
        configs: [
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.BLACK,
            },
            {
                materialType: tiles_1.MATERIAL_TYPES.CLASSIC,
                frameColor: frames_1.FRAME_COLORS.WHITE,
            },
            {
                materialType: tiles_1.MATERIAL_TYPES.WIDE_FRAME,
                frameColor: frames_1.FRAME_COLORS.BLACK,
            },
        ],
    },
];
function getFrameFromPresetConfig(presetId, frameIndex) {
    const preset = exports.WALL_FRAME_PRESET_CONFIG.find((preset) => preset.id === presetId);
    if (!preset) {
        return null;
    }
    return preset.configs[frameIndex % preset.configs.length];
}
exports.getFrameFromPresetConfig = getFrameFromPresetConfig;
const getUsedMaterialsInPreset = (presetId) => {
    var _a;
    return (0, uniq_1.default)(((_a = exports.WALL_FRAME_PRESET_CONFIG.find((preset) => (preset === null || preset === void 0 ? void 0 : preset.id) === presetId)) === null || _a === void 0 ? void 0 : _a.configs.map((config) => config.materialType)) || [
        tiles_1.MATERIAL_TYPES.CLASSIC,
    ]);
};
exports.getUsedMaterialsInPreset = getUsedMaterialsInPreset;
//# sourceMappingURL=galleryWallsPresets.js.map